<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item label="问卷中文名称">
              <j-input placeholder="请输入名称" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>

          <a-col  :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="科室">
            <a-select placeholder="请选择科室" v-model="queryParam.deptId" showSearch :filterOption="filterOption"
                @change="deptChange">
                <a-select-option :value="item.id" v-for="(item, index) in deptList" :key="index">
                  {{ item.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col  :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="亚专业" >
              <a-select placeholder="请选择亚专业" v-model="queryParam.submajorId" showSearch :filterOption="filterOption"
                @change="subMajorChange">
                <a-select-option :value="item.id" v-for="(item, index) in subMajorList" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col  :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="病种">
              <a-select placeholder="请选择病种" v-model="queryParam.diseaseId" showSearch :filterOption="filterOption">
                <a-select-option :value="item.id" v-for="(item, index) in diseaseList" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col  :xl="3" :lg="7" :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择状态" v-model="queryParam.statusValues" showSearch allow-clear mode="multiple" :filterOption="filterOption">
                <a-select-option :value="item.id" v-for="(item, index) in statusList" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col  :xl="3" :lg="7" :md="8" :sm="24">
            <a-form-item label="模块">
              <a-select placeholder="请选择模块" v-model="queryParam.modelType" showSearch allow-clear  :filterOption="filterOption">
                <a-select-option :value="item.id" v-for="(item, index) in modelTye" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                  <a-button @click="formDesignHandle" type="primary" style="margin-left: 8px">表单可视化</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="formName" slot-scope="text, record">          
          <a-tooltip placement="topLeft" v-if="isMissing(record)" style="padding-right:2px">
            <template slot="title">
              必填内容缺失
            </template>
            <a-icon type="info-circle" style="color: red" />
          </a-tooltip>
          <span>{{record.name}}</span>
        </span>
        <span slot="statusAction" slot-scope="text, record">          
          <span v-if="(record.status&15)==15">已完成 </span>
          <span v-else>
            <span>已新增 </span>
            <span v-if="(record.status&2)==2">已导入 </span>
            <span v-if="(record.status&8)==8">已附件 </span>
            <span v-if="(record.status&4)==4">已分类 </span>
          </span>        
          
          <span v-if="(record.status&16)==16">已审核 </span>
          <span v-if="(record.status&32)==32">已上线 </span>
        </span>        
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <template >
            <a-upload name="file" :data="{formId:record.id}" :showUploadList="false" :multiple="false" :headers="tokenHeader" style="margin-left: 8px" :action="importExcelUrl" @change="handleImportExcel">
                           <a>导入</a>
                  </a-upload>
                 <a-divider type="vertical" />
          </template>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="formViewHandle(record)">预览</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="formItemSetHandle(record)">表单设置</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="formGroupHandle(record)">表单归类</a>
              </a-menu-item>
              <a-menu-item v-has="'tempconfigform:del'">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'tempconfigform:audit'">
                <a-popconfirm :title="`您确定表单【${record.name}】审核通过吗? 审核通过后表单将无法修改！`" @confirm="() => handleAudit(record.id)">
                  <a>审核完成</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'tempconfigform:unaudit'">
                <a-popconfirm :title="`您确定将表单【${record.name}】改为未审核吗?`" @confirm="() => handleUnAudit(record.id)">
                  <a>取消审核</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <tempConfigForm-modal ref="modalForm" @ok="modalFormOk"></tempConfigForm-modal>
    <temp-config-form-item-set ref="formItemSet"></temp-config-form-item-set>
    <temp-config-form-group @reload="searchQuery" ref="formGroup"></temp-config-form-group>
    <form-design-model ref="modalFormDesign" @reload="searchQuery" kDesignType="CONFIG_FORM"></form-design-model>

    <a-drawer
      title="预览"
      width="60%"
      :closable="false"
      @close="onViewClose"
      :visible="viewVisible"
      
    >
      <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px">
        {{current.name}}
      </div>
      <base-form-view ref="baseFormView" :base-data="current" :is-view="true" @formChange="formChange"></base-form-view>

      <div style="text-align: right;margin-top: 20px">
        <a-popconfirm v-has="'tempconfigform:audit'" :title="`您确定表单【${current.name}】审核通过吗? 审核通过后表单将无法修改！`" type="primary" @confirm="() => handleAudit(current.id)">
          <a-button type="primary" danger>审核完成</a-button>
        </a-popconfirm>
        <a-button @click="onViewClose" style="margin-left: 20px">关闭</a-button>
        <a-button @click="submitItem" type="primary" style="margin-left: 20px">提交</a-button>
      </div>
    </a-drawer>

  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import TempConfigFormModal from './modules/TempConfigFormModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JInput from '@comp/jeecg/JInput.vue'
import TempConfigFormItemSet from '@views/tempconfig/form/TempConfigFormItemSet.vue'
import TempConfigFormGroup from '@views/tempconfig/form/TempConfigFormGroup.vue'
import FormView from '@views/project/components/FormView.vue'
import { getAction,postAction,putAction } from '@/api/manage'
import BaseFormView from '@comp/form/BaseFormView.vue'
import FormDesignModel from '@views/tempconfig/formDesign/FormDesignModel'

export default {
  name: "TempConfigFormList",
  mixins:[JeecgListMixin],
  components: {
    BaseFormView,
    FormView,
    TempConfigFormItemSet,
    JInput,
    TempConfigFormModal,
    TempConfigFormGroup,
    FormDesignModel,
  },
  data () {
    return {
      description: '项目配置-知识库-表单管理页面',
      // 表头
      columns: [
        {
          title: '问卷中文名称',
          align:"center",
          dataIndex: 'name',
          scopedSlots: { customRender: 'formName' },
        },
        // {
        //   title: '问卷问题数量',
        //   align:"center",
        //   dataIndex: 'number'
        // },
        // {
        //   title: '问卷英文名称',
        //   align:"center",
        //   dataIndex: 'nameEn'
        // },
        // {
        //   title: '预计用时（分钟）',
        //   align:"center",
        //   dataIndex: 'useTime'
        // },
        // {
        //   title: '是否是量表',
        //   align:"center",
        //   dataIndex: 'scale',
        //   customRender:(text)=>{
        //     let result = ''
        //     if('1'==text){
        //       result = '是'
        //     }
        //     if('0'==text){
        //       result = '否'
        //     }
        //     return result
        //   }
        // },
        {
          title: '创建者',
          align:"center",
          dataIndex: 'createName'
        },
        {
          title: '提交时间',
          align:"center",
          dataIndex: 'createTime'
        },
        {
          title: '更新者',
          align:"center",
          dataIndex: 'updateName'
        },
        {
          title: '状态',
          align:"center",
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusAction' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list: "/tempconfig/tempConfigForm/list",
        delete: "/tempconfig/tempConfigForm/delete",
      },
      current:{},
      viewVisible:false,
      diseaseList: [],
      subMajorList: [],
      deptList: this.initDept(),
      statusList:[ //1:已新增，2：已导入，4：已分类，8：已上传附件，16：已审核,32:已上线
        {id:1,name:'已新增'},
        {id:2,name:'已导入'},
        {id:4,name:'已分类'},
        {id:8,name:'已传附件'},
        {id:16,name:'已审核'},
        {id:32,name:'已上线'},
        {id:64,name:'已录入'},
        {id:-2,name:'未导入'},
        {id:-4,name:'未分类'},
        {id:-8,name:'未传附件'},        
        {id:-16,name:'未审核'},
        {id:-32,name:'未上线'},
        {id:-64,name:'未录入'},],
      modelTye:[ 
        {id:1,name:'通用'},
        {id:2,name:'专病'},],
    }
  
  },
  computed: {
    importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/tempconfig/tempConfigFormItem/importExcel`;
      }
  },
  methods: {
    
    initDept() {
      getAction('/tempconfig/tempConfigDept/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.deptList = res.result.records
          this.deptList.unshift({ "id": "0", "name": "所有科室" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initSubMajor() {
      getAction('/tempconfig/tempConfigSubmajor/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.subMajorList = res.result.records
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initDisease() {
      getAction('/tempconfig/tempConfigDisease/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.diseaseList = res.result.records
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    deptChange(vulue, option) {
      getAction('/tempconfig/tempConfigSubmajor/queryByDeptId', { id: this.queryParam.deptId }).then(res => {
        if (res.success) {
          this.subMajorList = res.result
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        }
      })
    },
    subMajorChange(vulue, option) {
      getAction('/tempconfig/tempConfigDisease/queryByDeptIdAndSubMajorId', { deptId: this.queryParam.deptId, subMajorId: this.queryParam.submajorId }).then(res => {
        if (res.success) {
          this.diseaseList = res.result
          this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
        }
      })

    },
    // diseaseChange(vulue, option) {
    //   if (this.model.type!='1') {
    //     if (this.model.diseaseId === "0") {
    //       this.model.moduleId = "0"
    //     } else {
    //       getAction('/tempconfig/tempConfigModule/queryByDiseaseId', { diseaseId: this.model.diseaseId }).then(res => {
    //         if (res.success) {
    //           this.model.moduleId = res.result.id
    //         }
    //       })
    //     }
    //   }
    // },
    formChange(formItem){
        if(this.$refs.baseFormView){
          const formData = this.$refs.baseFormView.getFormData()
          postAction('/tempconfig/tempConfigFormItem/cascade',{formId:this.current.id,formItemId:formItem.id,itemForm:JSON.stringify(formData)}).then(res=>{
            if(res.success){
              // if(!this.formItemHasRecord(formItem.id) && this.$refs.recording){
              //   this.$refs.recording.submitFormHandle(formItem,this.recordSubmitHandle(formItem.id))
              // }
              if(res.result){
                    for (let key in res.result){
                      this.$refs.baseFormView.setFormData(key,res.result[key])
                    }
                  }
              
              //质疑提示
              // postAction('/patient/patientForm/questionTip',{patientFormItemId:formItem.id}).then(res=>{
              //   if(res.success){
              //     debugger
              //     if(res.result!=null && res.result.length>0){
              //       this.$message.error({
              //       content: h(
              //           'div',
              //           { style: 'display:inline-table;text-align:left;vertical-align: top;max-width:300px;max-height:500px;' },
              //           res.result.map((line, index) => {
              //             return [
              //               (
              //                 'div',
              //                 { style: 'display:inline-table;text-align:left;vertical-align: top;' },
              //                 index+1 + "：" + line
              //               ),
              //               index < res.result.length - 1 ? <br /> : null
              //             ]
              //           })
              //         )
              //       })
              //     }
              //   }else{
              //     this.$message.error(res.message)
              //   }
              // })
            }else{
              this.$message.error(res.message)
            }
          })
        }
      },
    formItemSetHandle(record){
      this.$refs.formItemSet.view(record)
    },
    formDesignHandle(){
      this.$refs.modalFormDesign.view();
      this.$refs.modalFormDesign.setTargetTab('form_design');
    },
    formGroupHandle(record){
      this.$refs.formGroup.view(record)
    },
    onViewClose(){
      this.viewVisible = false
    },
    formViewHandle(record){
      getAction('/tempconfig/tempConfigForm/getInfoByCode',{code:record.code}).then(res=>{
        if(res.success){
          this.current = res.result
          this.viewVisible = true
        }
      })
    },
    handleAudit(id){
      putAction('/tempconfig/tempConfigForm/audit?id='+id).then(res=>{
        if(res.success){
          this.loadData();
          this.$message.success(res.message);
        }else{
          this.$message.error(res.message)
        }
      })
    },
    handleUnAudit(id){
      putAction('/tempconfig/tempConfigForm/unaudit?id='+id).then(res=>{
        if(res.success){
          this.loadData();
          this.$message.success(res.message);
        }else{
          this.$message.error(res.message)
        }
      })
    },
    submitItem(){
      if(this.$refs.baseFormView){
          const formData = this.$refs.baseFormView.getFormData()
          postAction('/tempconfig/tempConfigFormItem/formula',{formId:this.current.id,itemForm:JSON.stringify(formData)}).then(res=>{
            if(res.success){
              if(res.result){
                this.$refs.baseFormView.setFormItemResult(res.result)
              }              
            }else{
              this.$message.error(res.message)
            }
          })
        }
    },
    isMissing(record){
      if(!record){
        return true
      }
      if(!record.nameEn || !record.keyword || !record.useInfo || !record.number || !record.useTime){
        return true
      }
      return false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>